import React, { useEffect, useRef, useState } from "react";
import 'quill/dist/quill.snow.css';
import Editor from "./Editor";
import { ReplacementVariable } from "./ReplacementVariable";

const FormTemplate = ({ template, setTemplate, setEsValido, errors, saving, original }) => {
    const editorRef = useRef();
    const [variables, setVariable] = useState(ReplacementVariable[template.tipo ?? ""]);
    
    const onChangeProperty = (property, value) => {
        setTemplate((tmp) => ({
            ...tmp,
            [property]: value
        }));
    };

    const handleInsert = (text) => {
        editorRef.current.insertText(`{{ ${text} }}`, { });
    };

    useEffect(() => {
        setVariable(ReplacementVariable[template.tipo ?? ""]);

        if (!template.titulo || !template.content) {
            setEsValido(false);
            return;
        }
        
        setEsValido(true);
    }, [template]);


    return <>
        <div className="row mt-4">
            <div className="col-md-12">
                <div className="form-group">
                    <label>Titulo</label>

                    <input
                        name="titulo"
                        className="form-control"
                        onChange={e => onChangeProperty('titulo', e.target.value)}
                        value={template.titulo}
                        disabled={saving}
                    ></input>

                    {errors.titulo && (
                        <small className='help-blockParams form-Text'>
                            {errors.titulo[0]}
                        </small>
                    )}
                </div>
            </div>

            <div className="col-md-12">
                <div className="form-group">
                    <label>Plantilla</label>

                    <Editor ref={editorRef} value={template.content} onChange={e => onChangeProperty("content", e)} readOnly={saving} />
                </div>
            </div>

            <div className="col-12">
                <button type="button" className={`btn ml-auto mr-2 ${template.tipo === "EMPLEADOS" ? 'btn-primary' : 'btn-plain'}`}  onClick={() => onChangeProperty("tipo", 'EMPLEADOS')}>EMPLEADOS</button>
                <button type="button" className={`btn ml-auto mr-2 ${template.tipo === "CONTACTOS" ? 'btn-primary' : 'btn-plain'}`}  onClick={() => onChangeProperty("tipo", 'CONTACTOS')}>CONTACTOS</button>
                <button type="button" className={`btn ml-auto mr-2 ${template.tipo === "ESTUDIANTES" ? 'btn-primary' : 'btn-plain'}`}  onClick={() => onChangeProperty("tipo", 'ESTUDIANTES')}>ESTUDIANTES</button>
            </div>

            <div className="col-12 mt-2">
                <span>Variables</span>
                <div className="d-flex flex-wrap px-1 py-0">
                    {variables.map((variable) => <button key={variable.value} type="button" className="btn btn-link" onClick={() => handleInsert(variable.value)}>{variable.label}</button>)}
                </div>
            </div>
        </div>
    </>;
};

export default FormTemplate;